import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../util/Rest';
import {ATTORNEY} from '../../constants/MicroServiceConstants';

const initialData = {
  customerAttorneyData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'patientInteraction',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchCustomerAttorneyData: (state, action) => {
      state.customerAttorneyData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchCustomerAttorneyData, fetchStart, fetchError} = slice.actions;

export const fetchCustomerAttorney = (attorneyCode) => {
  return (dispatch) => {
    // http://65.0.39.33:9091/api/v1/attorney/find/attorney/{attorneyCode}
    dispatch(fetchStart());
    httpGet(`${ATTORNEY}/find/${ATTORNEY}/${attorneyCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchCustomerAttorneyData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
